module.exports = __webpack_public_path__ + "logo.png?c3842d860426b33a3e23f8ab5fc03c2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 67
// module chunks = 0